<form (ngSubmit)="onSubmit()" [formGroup]="form" class="vertical-form">

  <div class="tool-types-container flex-row gap-16 align-center">
    <!-- Primary Capture tool type -->
    <div>
      <mat-form-field class="capture-tool-form-field">
        <mat-label>Capture tool type</mat-label>
        <mat-select required formControlName="receiptToolTypeId" (selectionChange)="onReceiptToolTypeChange($event)">
          @for (s of receiptToolTypes; track s) {
            <mat-option [value]="s.value">{{ s.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    <!-- Additional selections displayed horizontally -->
    @for (toolTypeId of additionalToolTypes; track toolTypeId; let i = $index) {
      <div>
        <div class="additional-tool-container">
          <mat-form-field class="capture-tool-form-field">
            <mat-label>Capture tool type</mat-label>
            <mat-select [(ngModel)]="additionalToolTypes[i]" [ngModelOptions]="{standalone: true}"
              (selectionChange)="onAdditionalToolTypeChange(i)">
              @for (s of getAvailableToolTypes(i); track s) {
                <mat-option [value]="s.value">{{ s.name }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <lib-button variant="icon" color="warn" icon="remove_circle" (buttonClick)="removeToolType(i)"></lib-button>
        </div>
      </div>
    }

    <!-- Add button only shown when a non-None capture tool type is selected -->
    @if (showAddAdditionalButton()) {
      <div>
        <lib-button variant="icon" color="primary" icon="add_circle" (buttonClick)="addEmptyToolType()"></lib-button>
      </div>
    }
  </div>

  @if (!!allowScanning) {
    <div class="receipt-settings">
        <div>
        <!-- LEFT COL -->
        <div>
          <div class="box space-bottom">
            <mat-slide-toggle fxFlex formControlName="receiptManualVerification" color="primary">
              <label class="form-label">All receipts requires manual review</label>
            </mat-slide-toggle>
          </div>
          @if (isOCR && isContactSync) {
            <div class="box space-bottom">
              <mat-slide-toggle fxFlex formControlName="gloOrderSync" color="primary">
                <label class="form-label">GLO Order Sync</label>
              </mat-slide-toggle>
            </div>
          }
          <div class="box space-bottom">
            <mat-form-field fxFlex class="fingerprint-field">
              <mat-label>Fingerprint regex</mat-label>
              <input matInput type="text" placeholder="" formControlName="fingerprintRegex" step="1" autocomplete="off">
            </mat-form-field>
          </div>
          <div class="box space-bottom">
            <app-receipt-check-options-edit [formControl]="form.controls.receiptCheck"
            [timeConstraint]="form.controls.timeConstraint.value"></app-receipt-check-options-edit>
          </div>
          <div class="box space-bottom">
            <mat-slide-toggle fxFlex formControlName="timeConstraint" color="primary">
              <label class="form-label">Time constraint</label>
            </mat-slide-toggle>
          </div>
          <div class="box">
            <app-receipt-locations-check-options-edit [strategy]="strategy" #receiptLocationCheck
            [campaignId]="campaignId" [originalCampaignId]="originalCampaignId"></app-receipt-locations-check-options-edit>
          </div>
        </div>
        <!-- RIGHT COL -->
        <div>
        </div>
      </div>
    </div>
  }

  <!-- Manual Validation Panel -->
  @if (!!allowScanning && form.get('manualValidation')) {
    <div class="box space-bottom">
      <div class="line-head space-bottom">
        <b class="font1">Limit receipts scan</b>
      </div>
      <div formGroupName="manualValidation">
        <div class="fx-row">
          <div class="fx-col-1"></div>
          <div class="fx-col-2">
            <mat-slide-toggle formControlName="enabled" color="primary">
              <label class="form-label"> {{ form.get('manualValidation.enabled').value ? 'Enabled' : 'Disabled' }}</label>
            </mat-slide-toggle>
          </div>
        </div>
        <div class="fx-row">
          <div class="fx-col-1">
            <mat-form-field>
              <mat-label>Limit interval (days)</mat-label>
              <input matInput type="number" min="1" max="365" placeholder="" formControlName="windowDays">
              @if (!form.get('manualValidation.windowDays')?.valid) {
                <mat-error>Please enter a valid number of days
                (minimum 1)</mat-error>
              }
            </mat-form-field>
          </div>
          <div class="fx-col-2">
            <mat-form-field>
              <mat-label>Maximum receipts under (manual) review</mat-label>
              <input matInput type="number" min="1" max="10000" placeholder="" formControlName="maxReceipts">
              @if (!form.get('manualValidation.maxReceipts')?.valid) {
                <mat-error>Please enter a valid number (minimum
                1)</mat-error>
              }
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
  }

  @if (!!isSecretCode || !!isGLOIntegration) {
    <div>
      <h4 class="title" (click)="addNewVisual()">
        <mat-icon>add</mat-icon>
        Add guildline visual
      </h4>
      @for (item of guidelineImgs; track item; let i = $index) {
        <div class="avatar-container banner"
          (click)="fileInputBanner.click()">
          <mat-icon class="close-btn" color="primary" (click)="removeVisual($event, i)">close</mat-icon>
          <input class="hidden" #fileInputBanner type="file" accept="image/*"
            (change)="onBannerImageSelected($event, item)">
          <div class="icon-container" matTooltip="Upload banner">
            <mat-icon color="primary">photo_camera</mat-icon>
          </div>
          <div class="banner">
            <lib-photo [url]="item.img" [width]="'195px'" [height]="'130px'" [radius]="'10px'"></lib-photo>
          </div>
          @if (!item.img && !item.uploadBannerKey) {
            <div class="image-info">Banner 16:9</div>
          }
        </div>
      }
    </div>
  }
</form>
